import { AppHeaderDropdown, ChatHeader, useLayoutContext, useUserContext } from '@lemonade-hq/nuiza';
import type React from 'react';
import { Unauthorized } from './Unauthorized';

const consumerUrl = window.lemonade?.config?.urls?.consumerUrl ?? 'https://me.lemonade.com';
const logoutUrl = `${window.location.origin}/auth/logout`;

export const Error: React.FC = () => {
  const { getAccountDropdownSettings } = useLayoutContext();
  const { user } = useUserContext();
  const headerDropdownSettings = getAccountDropdownSettings?.();

  if (!headerDropdownSettings) return null;

  const chatHeader = ({ withRep = false, trackingContext = 'home-check-error-page' }): JSX.Element => (
    <ChatHeader
      actions={[
        <AppHeaderDropdown
          accountDropdownOptionsSettings={headerDropdownSettings}
          firstName={user?.givenName}
          key="user"
          lastName={user?.familyName}
          trackingContext={trackingContext}
        />,
      ]}
      rep={withRep ? 'maya' : undefined}
    />
  );

  return (
    <>
      {chatHeader({
        trackingContext: 'home-check-error-page-unauthorized',
      })}
      <Unauthorized backHomeUrl={consumerUrl} logoutUrl={logoutUrl} />
    </>
  );
};
